const initialState = {
    modalTitle: '',  //新增  编辑 项目
    projectName: '',
    projectCreater: '',
    projectContent: '',
    projectAttachment: [],
    platform: [],
    defaultGroup: '' 
}

export default function  projectReducer (state = initialState, action) {
    switch(action.type){
        //modal名称
        case 'CHANGE_MODAL_TITLE': return Object.assign({}, state, {
            modalTitle: action.payload
        })
        //项目名称
        case 'CHANGE_PROJECT_NAME': return Object.assign({}, state, {
            projectName: action.payload,
        });
        //项目创建人
        case 'CHANGE_PROJECT_CREATER': return Object.assign({}, state, {
            projectCreater: action.payload
        });
        //项目内容
        case 'CHANGE_PROJECT_CONTENT': return Object.assign({}, state, {
            projectContent: action.payload
        });
        //项目附件
        case 'CHANGE_PROJECT_ATTACHMENT': return Object.assign({}, state, {
            projectAttachment: action.payload

        })
        // //拟发平台
        // case 'CHANGE_PLATFORM': console.log(action.payload);return Object.assign({}, state, {
        //     platform: action.payload
            
        // })
        // case 'CHANGE_GROUP': return Object.assign({}, state, {
        //     defaultGroup: action.payload
        // })
        //清空所有数据
        case 'RESET_DATA': console.log('clear');return Object.assign({}, state, {
            projectName: '',
            projectCreater: '',
            projectContent: '',
            platform:[],
            projectAttachment:[],
            defaultGroup:[]
        })
        default : return state
    }
}
